/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2021-07-23 13:20:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\utils\server.js
 */
/**
 * http配置
 */
import Vue from 'vue';
import axios from 'axios'
import {
	Toast
} from 'vant';
import {
	getToken,
	setToken,
} from '@/utils/auth'
// import common from '@/utils/config'
Vue.use(Toast);

var httpConfig = {
	// baseURL: 'https://testwap.liangbaba.com/zuul',  // 接口地址
	// baseURL: common.baseURL,  // 接口地址
	timeout: 20000,
}
//基地址
const instance = axios.create(httpConfig)

//请求拦截器
instance.interceptors.request.use(
	config => {
		config.headers['content-type'] = 'application/json;charset=UTF-8'
		//请求拦截给请求头里放个token
		//console.log('请求拦截给请求头里放个token',getToken());
		//setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0eXBlIjoiMSIsImV4cCI6MTU5ODg0MTI5MCwidXNlcm5hbWUiOiJhZG1pbiJ9.IvqL7yat1bb2_ThXbSgz5VmszBDtQwWGl--WAf-BD3A')
		if (getToken()) {
			//config.headers.Authorization = getToken();
			// config.headers['token'] = getToken();
		}
		return config
	},
	err => {
		return Promise.reject(err)
	}

)

//响应拦截器
instance.interceptors.response.use(
	response => {
		//重置Token
		var token = response.headers['token']
		if (token != undefined) {
			setToken(token)
		}
		//console.log(response)
		const res = response.data
		return res
	},
	error => {
		console.log('error' + error) // for debug
		Toast({
			message: '请求失败',
		});
		return Promise.reject(error)
	}
)
export default instance



// WEBPACK FOOTER //
// ./src/utils/server.js